const twoThirdOneThird = {
    TwoThirdOneThird: {
        baseStyle: ({backgroundColor, isBeforeRightMobile, isBeforeRightDesk}) => ({
            grid: {
                templateColumns: 'repeat(12, 1fr)',
                gap: 'spacing.0',
                maxH: {base: 'unset', md: '61.3vw'},
                overflow: 'hidden',
            },
            gridItemLeft: {
                colSpan: {base: 12, md: 8},
                maxH: 'inherit',
            },
            gridItemRight: {
                colSpan: {base: 12, md: 4},
                order: {base: isBeforeRightMobile ? '-1' : 'unset', md: isBeforeRightDesk ? '-1' : 'unset'},
                maxH: 'inherit',
            },
            wrapper: {
                bg: backgroundColor ? backgroundColor : 'color.background.transparent',
                w: '100%',
                gridColumn: '1 / -1', // Starts from the first column end ends at the last column
            },
        }),
    },
}
export default twoThirdOneThird
